<ng-container *transloco="let t">

  <button mat-flat-button type="button" color="accent" (click)="viewCode(codeTmpl)">
    <mat-icon>visibility</mat-icon>
    {{t('condition-report.viewCode')}}
  </button>

  <ng-template #codeTmpl>
    <div class="row">
      <div class="col-12">
        <h2>{{(step$ | async)?.title }}</h2>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <form *ngIf="conditionForm$ | async as conditionForm" [formGroup]="conditionForm">
          <ngx-monaco-editor class="conditionEditor" [options]="codeEditorOptions" formControlName="code">
          </ngx-monaco-editor>
        </form>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <label class="font-weight-bold">{{t('condition-report.targetResult')}}:</label><span> {{targetResult$ |
          async}}</span>
      </div>
    </div>
  </ng-template>

</ng-container>
